import axios from 'axios'

export type InteractionFilter = {
  query?: string
  fromDate?: string
  toDate?: string
  repId?: number
  rayonId?: number
  brickId?: number
  productId?: number
  tierId?: number
  onlyPlanned?: boolean
  userId?: number
  labelId?: number
  clientId?: number
  targeted?: boolean
  therapeuticAreaId?: number
  view?: 'collapsed' | 'exploded'
}

export type InteractionPage = InteractionFilter & {
  limit?: number
  offset?: number
}

export default class InteractionService {
  public getById(id) {
    return axios.get('/api/v1/interactions/' + id)
  }

  public getAll(page: InteractionPage) {
    return axios.get('/api/v1/interactions', { params: page })
  }

  public getByClientIdAndProductId(clientId, productId) {
    return axios.get(
      '/api/v1/clients/' + clientId + '/interactions/products/' + productId,
    )
  }

  public getInteractionsWithoutProductsByClientId(clientId) {
    return axios.get(
      '/api/v1/clients/' + clientId + '/interactions/no-products/',
    )
  }

  public getByProductId(productId) {
    return axios.get('/api/v1/products/' + productId + '/interactions/products')
  }

  public getAllExcel(filter: InteractionFilter) {
    return axios.get('/api/v1/interactions/export', {
      responseType: 'blob',
      params: filter,
    })
  }

  public create(interaction: any) {
    return axios.post('/api/v1/interactions', interaction)
  }

  public update(interaction: any) {
    return axios.post(`/api/v1/interactions/${interaction.id}`, interaction)
  }

  public delete(interaction: any) {
    return axios.delete(`/api/v1/interactions/${interaction.id}`)
  }

  public last(userId, cycleId) {
    return axios.get('/api/v1/interactions/get-last', {
      params: {
        userId,
        cycleId,
      },
    })
  }
}
